(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/play.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/play.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Play = Backbone.Model.extend({
    log: new svs.core.log.Logger('svs.models.Play'),
    defaults: {
      isSingleRow: false,
      isReduceMode: false,
      isMatchView: false
    },

    getDataFromLocalStorage: function() {
      if (svs.tipset.data.isProlong) {
        svs.tipset.objects.localstorageHandler.getProlongWagerFromLocalStorage();
      } else {
        svs.tipset.objects.localstorageHandler.getDataFromLocalStorage();
      }
    },

    toggleSingleRow: function() {
      var here = svs.tipset.models.play;
      var setIsSingleRow = !here.get('isSingleRow');
      here.setModels(setIsSingleRow);
      svs.tipset.objects.localstorageHandler.clearLocalStorage();
      here.disableReduceMode();
      here.setIsSingleRow(!here.get('isSingleRow'));

      here.save();
    },

    enableReduceMode: function() {
      if (this.get('isReduceMode')) {
        return;
      }

      this.setIsReduceMode(true);

      this.save();
      if (svs.utils.initContextMenu) {
        svs.utils.initContextMenu();
      }

      setTimeout(function() {
        svs.tipset.views.actionbar.removeActionBar();
      });
    },

    disableReduceMode: function() {
      if (!this.get('isReduceMode')) {
        return;
      }

      svs.tipset.objects.localstorageHandler.clearLocalStorage();
      this.setIsReduceMode(false);

      this.save();
      if (svs.utils.initContextMenu) {
        svs.utils.initContextMenu();
      }
    },

    setIsSingleRow: function(isSingleRowValue) {
      this.set('isSingleRow', isSingleRowValue, { silent: true });
      this.trigger('change', this, { isSingleRow: isSingleRowValue });
      this.trigger('changeSingleRows', isSingleRowValue);
    },

    setIsReduceMode: function(isReduceModeValue) {
      this.set('isReduceMode', isReduceModeValue, { silent: true });
      if (svs.utils.initContextMenu) {
        svs.utils.initContextMenu();
      }
      this.trigger('change', this, { isReduceMode: isReduceModeValue });
    },

    setDataFromLocalStorage: function() {
      var hasSavedData =
        svs.tipset.objects.localstorageHandler &&
        svs.tipset.objects.localstorageHandler.dataFromLocalStorage,
        isTransferWager =
          hasSavedData &&
          svs.tipset.objects.localstorageHandler.dataFromLocalStorage
            .isTransferWager,
        isProlongWager =
          hasSavedData &&
          svs.tipset.objects.localstorageHandler.dataFromLocalStorage
            .isProlongWager,
        isSingleRow = false,
        isReduceMode = svs.tipset.objects.localstorageHandler.isReduceMode;
      if (isTransferWager || isProlongWager) {
        isSingleRow =
          !svs.core.detect.formfactor.mobile() &&
          svs.tipset.objects.localstorageHandler.dataFromLocalStorage
            .isSingleRow;
      } else {
        isSingleRow =
          !svs.core.detect.formfactor.mobile() &&
            svs.tipset.objects.localstorageHandler &&
            svs.tipset.objects.localstorageHandler.isSingleRow
            ? svs.tipset.objects.localstorageHandler.isSingleRow
            : false;
      }

      if (svs.tipset.data.competition) {
        isSingleRow = false;
        isReduceMode = false;
        if (svs.tipset.objects.localstorageHandler.isSingleRow) {
          svs.tipset.objects.localstorageHandler.clearSingleRowInLocalStorage();
          svs.tipset.objects.localstorageHandler.clearLocalStorage();
        }
      }

      this.set('isTransferWager', isTransferWager, { silent: true });
      this.setModels(isSingleRow);
      this.setIsSingleRow(isSingleRow);
      this.setIsReduceMode(isReduceMode);
    },

    setModels: function(isSingleRow) {
      var betAmount = svs.utils.ns.isNamespace(
        'svs.tipset.objects.localstorageHandler.dataFromLocalStorage.betAmount'
      )
        ? svs.tipset.objects.localstorageHandler.dataFromLocalStorage
          .betAmount
        : svs.tipset.models.gameDefinitions.get('rowPrices')[0],
        hasInitMach =
          svs.tipset.data.params &&
          svs.tipset.data.params.mid &&
          parseInt(svs.tipset.data.params.mid, 10) > 0;

      if (
        svs.competition &&
        svs.competition.core &&
        svs.competition.core.data.canPlayTipsSM &&
        svs.competition.Helper &&
        (svs.competition.Helper.userIsParticipatingInTipsSM() ||
          svs.competition.core.data.canRegisterForTipsSM)
      ) {
        if (svs.tipset.models.competition) {
          svs.tipset.models.competition.reset();
        } else {
          svs.tipset.models.competition = new svs.tipset.models.Competition(
            svs.competition.core.data.tipsSMCompetition
          );
        }
      }
      if (svs.tipset.models.betslipFooter) {
        svs.tipset.models.betslipFooter.destroy();
      }

      if (svs.tipset.models.betslipExpanded) {
        svs.tipset.models.betslipExpanded.destroy();
      }

      if (svs.tipset.models.bombenXperten) {
        svs.tipset.models.bombenXperten.reset();
      }

      if (isSingleRow) {
        if (svs.tipset.collections.matchlist) {
          svs.tipset.collections.matchlist.reset();
        }

        if (!svs.tipset.models.xpertenSystemsSingleRow) {
          svs.tipset.models.xpertenSystemsSingleRow = new svs.tipset.models.SingleRowXpert();
        } else {
          svs.tipset.models.xpertenSystemsSingleRow.clearAll();
        }

        if (!svs.tipset.collections.boardCollections) {
          svs.tipset.collections.boardCollections = new svs.tipset.collections.SingleRowBoards();
        } else {
          svs.tipset.collections.boardCollections.reset();
        }
      } else {
        if (svs.tipset.collections.boardCollections) {
          svs.tipset.collections.boardCollections.reset();
        }

        if (svs.tipset.models.xpertenSystemsSingleRow) {
          svs.tipset.models.xpertenSystemsSingleRow.destroy();
        }

        if (!svs.tipset.models.xpertenSystems) {
          svs.tipset.models.xpertenSystems = new svs.tipset.models.XpertenSystems();
        } else {
          svs.tipset.models.xpertenSystems.clearAll();
        }

        if (!svs.tipset.models.statistics) {
          svs.tipset.models.statistics = new svs.tipset.models.Statistics();
        }

        if (!svs.tipset.models.systems) {
          svs.tipset.models.systems = new svs.tipset.models.Systems();
        } else {
          svs.tipset.models.systems.reset();
        }

        if (!svs.tipset.models.coupon) {
          svs.tipset.models.coupon = new svs.tipset.models.NewCoupon();
        }

        if (!svs.tipset.collections.matchlist) {
          svs.tipset.collections.matchlist = new svs.tipset.collections.Matchlist(
            svs.tipset.collections.draws.getCurrentDraw().get('drawEvents')
          );
        } else {
          svs.tipset.collections.matchlist.resetCollection(
            svs.tipset.collections.draws.getCurrentDraw().get('drawEvents')
          );
        }
        if (
          (!svs.core.detect.formfactor.mobile() || this.get('isMatchView')) &&
          hasInitMach
        ) {
          svs.tipset.collections.matchlist.setInitialMatch({
            eventNumber: svs.tipset.data.params.mid
          });
        }
      }

      if (svs.tipset.models.gameDefinitions.hasWeekPicker()) {
        if (!svs.tipset.models.weekPicker) {
          svs.tipset.models.weekPicker = new svs.tipset.models.WeekPicker();
        } else {
          svs.tipset.models.weekPicker.clearAll();
        }
      }

      if (svs.tipset.models.gameDefinitions.hasSportkryss()) {
        if (!svs.tipset.models.sportkryss) {
          svs.tipset.models.sportkryss = new svs.tipset.models.Sportkryss();
        } else {
          svs.tipset.models.sportkryss.clearAll();
        }
      }

      if (!svs.tipset.models.betslipExpanded) {
        svs.tipset.models.betslipExpanded = new svs.tipset.models.BetslipExpanded(
          { amount: betAmount }
        );
      } else {
        svs.tipset.models.betslipExpanded.setAmount(betAmount);
      }

      svs.tipset.models.betslipFooter = isSingleRow
        ? new svs.tipset.models.BetslipSinglerows()
        : new svs.tipset.models.BetslipFooter();
    },

    setIsMatchView: function(isMatchView) {
      this.set('isMatchView', isMatchView, { silent: true });
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveSingleModeToLocalStorage();
      svs.tipset.objects.localstorageHandler.saveReduceModeToLocalStorage();
    }
  });
})(Backbone, _, svs);

 })(window);